import { Chip, Tooltip, Typography } from '@mui/material';
import { NEAR_PAR_LABEL, NEAR_PAR_RATE_LABEL, NEAR_PAR_TOOLTIP } from './pricingUtils';

export const NearParBadge = ({ sx } = {}) => (
  <Tooltip title={NEAR_PAR_TOOLTIP} arrow>
    <Chip
      label={NEAR_PAR_LABEL}
      size="small"
      color="warning"
      variant="outlined"
      sx={{ height: 18, fontSize: '0.55rem', maxWidth: '100%', ...sx }}
    />
  </Tooltip>
);

export const NearParRateLabel = ({ variant = 'caption', sx } = {}) => (
  <Tooltip title={NEAR_PAR_TOOLTIP} arrow>
    <Typography
      variant={variant}
      color="text.secondary"
      component="div"
      sx={{ borderBottom: '1px dotted', borderColor: 'text.disabled', cursor: 'help', display: 'inline-block', ...sx }}
    >
      {NEAR_PAR_RATE_LABEL}
    </Typography>
  </Tooltip>
);
